
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import moment from 'moment';
import { Route } from 'vue-router';
import Swal from 'sweetalert2';
import ItemForm from './Form.vue';

const { popularProductUrl } = api;

@Component({
  components: { ItemForm },
})
export default class PopularProductUrlEdit extends Vue {
  @Prop({}) private id!: string;

  private form = {
    url: null,
    label: null,
    startOn: null,
    endOn: null,
  };

  private loading: boolean = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await popularProductUrl.update(this.id, form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        await this.$router.back();
      }
    }
  }

  private setForm(data: any) {
    this.form = data;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: PopularProductUrlEdit) => void) => void,
  ) {
    const { id } = to.params;
    const { data } = await popularProductUrl.get(id);
    data.startOn = moment(data.startOn).format('YYYY-MM-DD HH:mm');
    data.endOn = moment(data.endOn).format('YYYY-MM-DD HH:mm');
    await next(async (vm) => {
      vm.setForm(data);
    });
  }
}
